import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-86681438"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header p-d-flex p-ai-center p-jc-between m-y-3" }
const _hoisted_2 = { class: "text-white t3" }
const _hoisted_3 = { class: "text-primary medium label p-ml-2" }
const _hoisted_4 = { class: "table__wrapper p-grid" }
const _hoisted_5 = { class: "p-col-2 p-p-0 text-white medium p3" }
const _hoisted_6 = { class: "p-col-2 p-p-0 text-white medium p3" }
const _hoisted_7 = { class: "p-col-3 p-p-0 text-white medium p3" }
const _hoisted_8 = { class: "p-col-2 p-p-0 text-white medium p3" }
const _hoisted_9 = { class: "p-col-2 p-p-0 p-text-center text-white medium p3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-col-1 p-p-0" }, null, -1))
const _hoisted_11 = { class: "billing-history__wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_skeleton_invoice_card = _resolveComponent("skeleton-invoice-card")!
  const _component_edit = _resolveComponent("edit")!
  const _component_icon = _resolveComponent("icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_invoice = _resolveComponent("invoice")!
  const _component_custom_transition = _resolveComponent("custom-transition")!
  const _component_billing_history_item = _resolveComponent("billing-history-item")!
  const _component_placeholder_state = _resolveComponent("placeholder-state")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isLoding)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_skeleton_invoice_card),
          _createVNode(_component_skeleton_invoice_card),
          _createVNode(_component_skeleton_invoice_card),
          _createVNode(_component_skeleton_invoice_card)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.copies.title), 1),
            _createVNode(_component_Button, {
              class: "tertiary",
              onClick: _ctx.handleShowFormToEditBillingInfo
            }, {
              default: _withCtx(() => [
                _createVNode(_component_icon, {
                  strokeColor: "var(--primary)",
                  size: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_edit)
                  ]),
                  _: 1
                }),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.copies.ctaEdit), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          (_ctx.billingList.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.copies.tableHeading.month), 1),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.copies.tableHeading.camada), 1),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.copies.tableHeading.course), 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.copies.tableHeading.amount), 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.copies.tableHeading.billing), 1),
                  _hoisted_10
                ]),
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billingList, (data, index) => {
                    return (_openBlock(), _createBlock(_component_billing_history_item, {
                      key: data._id,
                      item: data,
                      onOnToggleDetail: _ctx.handleOpenInvoice,
                      isEven: index % 2 === 0
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_custom_transition, null, {
                          default: _withCtx(() => [
                            (_ctx.isOpen && _ctx.invoiceId === data._id)
                              ? (_openBlock(), _createBlock(_component_invoice, {
                                  key: 0,
                                  data: _ctx.invoiceDetail,
                                  onOnUpload: _ctx.handleUploadForm
                                }, null, 8, ["data", "onOnUpload"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["item", "onOnToggleDetail", "isEven"]))
                  }), 128))
                ])
              ], 64))
            : (_openBlock(), _createBlock(_component_placeholder_state, {
                key: 1,
                class: "p-mt-3",
                role: 3,
                isEmpty: "",
                customCopies: { line1: _ctx.copies.empty }
              }, null, 8, ["customCopies"]))
        ], 64))
  ]))
}